import "./unverifiedNavBar.css";
import { withRouter, Link } from "react-router-dom";

function UnverifiedNavBar(props) {
  return (
    <div className="top-navigation-div unverified-nav-bar">
      <div className="logo-div">
        <Link to="/dashboard">
          <img className="logo" src={"/themes/" + props.theme + "/logo.png"} />
        </Link>
        <Link to="/dashboard" className="title">
          {process.env.REACT_APP_TITLE}
        </Link>
      </div>
    </div>
  );
}

export default withRouter(UnverifiedNavBar);
